import { IDevice } from '@pages/Assets/Inventory/types';
import { useCallback } from 'react';
import { IDeviceActionRequestPayload } from '../types';

interface IUActionSimcardReset {
  handleDeviceActions: (item: IDeviceActionRequestPayload) => void;
  actionKey: number;
  devicesProps: IDevice[] | undefined;
  uploadedDevices: any;
}

const useActionSimcardReset = ({
  handleDeviceActions,
  actionKey,
  devicesProps,
  uploadedDevices,
}: IUActionSimcardReset) => {
  const contentSteps: [] = [];

  const onSubmit = useCallback(async () => {
    const payload: IDeviceActionRequestPayload = {};
    payload.action = actionKey;

    payload.devices =
      devicesProps && devicesProps?.length > 0
        ? devicesProps?.map(device => ({
            msisdn: device.msisdn,
            iccid: device.iccid,
          }))
        : uploadedDevices;
    return handleDeviceActions(payload);
  }, [actionKey, devicesProps, uploadedDevices, handleDeviceActions]);

  const simcardResetData = {
    contentSteps,
    onSubmit,
  };

  return { simcardResetData };
};

export default useActionSimcardReset;
